import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
// Selectors
import { selectFilter } from 'src/store/selectors/filters'
// Components
import { Text } from 'src/Components'
import FilterCheckBox from 'src/Components/homeSearch/Filters/FilterCheckBox'
// Constants
import {
  HOME_TYPES_HOUSE,
  HOME_TYPES_APTCONDO,
  HOME_TYPES_TOWNHOUSE,
  HOME_TYPES_LOTLAND,
} from 'src/constants/listings'
// Styles
import styles from './HomeType.module.scss'
import filterStyles from '../Filters.module.scss'

const HomeType = () => {
  const filters = useSelector(selectFilter)
  const [homeTypeAll, setHomeTypeAll] = useState(false)
  const [homeTypeHouse, setHomeTypeHouse] = useState(false)
  const [homeTypeAptCondo, setHomeTypeAptCondo] = useState(false)
  const [homeTypeTownHouse, setHomeTypeTownHouse] = useState(false)
  const [homeTypeLotLand, setHomeTypeLotLand] = useState(false)

  useEffect(() => {
    setHomeTypeHouse(filters.propertyTypes.includes(HOME_TYPES_HOUSE))
    setHomeTypeAptCondo(filters.propertyTypes.includes(HOME_TYPES_APTCONDO))
    setHomeTypeTownHouse(filters.propertyTypes.includes(HOME_TYPES_TOWNHOUSE))
    setHomeTypeLotLand(filters.propertyTypes.includes(HOME_TYPES_LOTLAND))
  }, [filters])

  useEffect(() => {
    setHomeTypeAll(
      !homeTypeHouse &&
        !homeTypeAptCondo &&
        !homeTypeTownHouse &&
        !homeTypeLotLand
    )
  }, [homeTypeHouse, homeTypeAptCondo, homeTypeTownHouse, homeTypeLotLand])

  const handleHomeTypeAll = () => {
    setHomeTypeAll(true)
    setHomeTypeHouse(false)
    setHomeTypeAptCondo(false)
    setHomeTypeTownHouse(false)
    setHomeTypeLotLand(false)
  }

  const handleHomeType = (setter, val) => {
    setter(!val)
    if (!val) {
      setHomeTypeAll(val)
    }
  }

  return (
    <>
      <Text
        align='left'
        element='h2'
        weight='bold'
        variant='neutralCool'
        variantCount='900'
        className={filterStyles.sectionTitle}
      >
        <FormattedMessage
          id='HomeSearch.listings.filters.homeType.heading'
          defaultMessage='Home type'
        />
      </Text>
      <div className={styles.checkBoxFields}>
        <FilterCheckBox
          checked={homeTypeAll}
          name='homeTypesAll'
          onChange={handleHomeTypeAll}
        >
          <FormattedMessage
            id='HomeSearch.listings.filters.homeType.all'
            defaultMessage='All'
          />
        </FilterCheckBox>
        <FilterCheckBox
          checked={homeTypeHouse}
          name={HOME_TYPES_HOUSE}
          data-qa={HOME_TYPES_HOUSE}
          onChange={() => handleHomeType(setHomeTypeHouse, homeTypeHouse)}
        >
          <FormattedMessage
            id='HomeSearch.listings.filters.homeType.house'
            defaultMessage='House'
          />
        </FilterCheckBox>
        <FilterCheckBox
          checked={homeTypeAptCondo}
          name={HOME_TYPES_APTCONDO}
          data-qa={HOME_TYPES_APTCONDO}
          onChange={() => handleHomeType(setHomeTypeAptCondo, homeTypeAptCondo)}
        >
          <FormattedMessage
            id='HomeSearch.listings.filters.homeType.aptCondo'
            defaultMessage='Apartment / Condo'
          />
        </FilterCheckBox>
        <FilterCheckBox
          checked={homeTypeTownHouse}
          name={HOME_TYPES_TOWNHOUSE}
          data-qa={HOME_TYPES_TOWNHOUSE}
          onChange={() =>
            handleHomeType(setHomeTypeTownHouse, homeTypeTownHouse)
          }
        >
          <FormattedMessage
            id='HomeSearch.listings.filters.homeType.townhouse'
            defaultMessage='Townhouse'
          />
        </FilterCheckBox>
        <FilterCheckBox
          checked={homeTypeLotLand}
          name={HOME_TYPES_LOTLAND}
          data-qa={HOME_TYPES_LOTLAND}
          onChange={() => handleHomeType(setHomeTypeLotLand, homeTypeLotLand)}
        >
          <FormattedMessage
            id='HomeSearch.listings.filters.homeType.lotLand'
            defaultMessage='Lot / Land'
          />
        </FilterCheckBox>
      </div>
    </>
  )
}

export default HomeType
